(function() {
    'use strict';

    angular.module("imApp").factory("productStructuresService", ['$ihttp', function($ihttp) {
        var service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3974,
                    parameters: parms || {}
                });
            },


        };

        return service;
    }]);
})();
